import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'levelExtract'
})
export class LevelExtractPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return 'N/A';
    const match = value.match(/^Level\s*\d+/i);
    return match ? match[0] : value;
  }
}
